import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Completely suppress ResizeObserver loop errors
// This is a known browser issue that doesn't affect functionality
if (typeof window !== 'undefined') {
  // Patch ResizeObserver to catch errors silently
  const RO = window.ResizeObserver;
  window.ResizeObserver = class PatchedResizeObserver extends RO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            // Silently ignore
          }
        });
      });
    }
  };

  // Suppress console.error for ResizeObserver
  const originalError = window.console.error;
  window.console.error = (...args) => {
    if (args.some(arg => String(arg).includes('ResizeObserver'))) return;
    originalError.apply(console, args);
  };

  // Suppress global errors
  window.addEventListener('error', (event) => {
    if (String(event.message || '').includes('ResizeObserver')) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return true;
    }
  }, true);

  // Override window.onerror
  const originalOnError = window.onerror;
  window.onerror = function(message) {
    if (String(message).includes('ResizeObserver')) return true;
    if (originalOnError) return originalOnError.apply(this, arguments);
    return false;
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
